import { ChapterSection } from "../ServicesMenuChapter.interface";
import { motion } from "framer-motion";
import SectionHeader, { SectionHeaderProps } from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import SectionMedia from "./SectionMedia";
import {
    CAROUSEL_ITEM_HEADER_HEIGHT,
    CAROUSEL_ITEM_MEDIA_WIDTH,
    CAROUSEL_ITEM_PADDING
} from "./SectionLayout.constants";
import { GradualSpacing } from '../../../effects/GradualSpacing';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import {
    LARGE_VARIANT_CONFIG,
    usePosterTitle,
} from "./usePosterTitle.hook";
import { DEFAULT_TRANSITION_DURATION } from '../ServiceMenuChapter.constants';

interface EntrySectionLayoutProps {
    section: ChapterSection,
    headerSettings: SectionHeaderProps,
    isEntrySection: boolean,
}

const CAROUSEL_VARIANT_2_SETTINGS = {
    mediaHeight: 77.6, // 1490
}

function SectionLayoutVariant2(props: EntrySectionLayoutProps) {
    const {
        headerSettings,
        section,
        isEntrySection,
    } = props;
    const {
        media,
        title,
    } = section;

    const computedTitleSize = usePosterTitle(title, LARGE_VARIANT_CONFIG);

    return (
        <VariantWrapper section={section}>
            <SectionHeader {...headerSettings} />

            <TextWrapper
                style={{
                    padding: `2.6vh ${CAROUSEL_ITEM_PADDING}vh 5.21vh ${CAROUSEL_ITEM_PADDING}vh`,
                    top: `${CAROUSEL_ITEM_HEADER_HEIGHT}vh`,
                    left: 0,
                    fontSize: `${computedTitleSize.fontSize}vh`,
                    lineHeight: `${computedTitleSize.lineHeight}vh`,
                    textTransform: 'uppercase',
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                }}
            >
                <GradualSpacing text={title} offset={1} />
            </TextWrapper>

            <motion.div
                style={{
                    position: 'absolute',
                    zIndex: 200,
                }}
                initial={isEntrySection ? {
                    width: '100vw',
                    height: '100vh',
                    x: 0,
                    y: 0,
                } : false}
                animate={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_2_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: `calc(100vh - ${CAROUSEL_VARIANT_2_SETTINGS.mediaHeight}vh - ${CAROUSEL_ITEM_PADDING}vh)`,
                    transition: {
                        ease: NIKE_EASE,
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
                exit={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_2_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: '-100vh',
                    transition: {
                        ease: 'easeIn',
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
            >
                <SectionMedia media={media}/>
            </motion.div>
        </VariantWrapper>
    )
}

export default SectionLayoutVariant2;
